import { render, staticRenderFns } from "./EscuelasForm.vue?vue&type=template&id=597046c6&"
import script from "./EscuelasForm.vue?vue&type=script&lang=js&"
export * from "./EscuelasForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports